import React, { useState } from "react";
import { useQuery } from "@apollo/react-hooks";
import { useHistory, useLocation } from "react-router-dom";

import * as S from "./styles";
import { IProps } from "./types";
import { orders, ordersVariables } from "@components/pages/OrderListPage/__generated__/orders";
import { ORDERS } from "@components/pages/OrderListPage/queries";
import { orderUrl } from "@src/app/routes";
import { Loading, LabelStatus, BreadCrumb } from "@atoms";
import { Table } from "react-bootstrap";
import { OffsetPagination } from "@molecules";
import { getDateTime, getPrice } from "@utils";
import { accountUrl } from "@src/app/routes";
import { useAlert } from "react-alert";
import { PaymentChargeStatusEnum } from "__generated__/globalTypes";

const OrderListPage: React.FC<IProps> = ({}) => {
  const ordersToShow = 12;
  const location = useLocation();
  const paths = location.pathname.split('/').filter(
    (path, idx) => {
      return path !== "";
    })
  const lastPath = paths[paths.length - 1];

  const initialVariables = {first: ordersToShow}
  if (lastPath === "active-orders") {
    initialVariables['status'] = "READY_TO_FULFILL";
  }

  const [variables, setVariables] =
    useState<ordersVariables>(initialVariables);

  const alert = useAlert();
  const {data, error, loading} = useQuery<orders>(ORDERS, {
    variables,
    fetchPolicy: "no-cache",
  });

  const history = useHistory();
  const redirectToMyOrderDetailPage = (token: string) => {
    history.push(`${orderUrl}${token}/`);
  }
  const breadCrumbData = [
    {
      name: "My Account",
      link: accountUrl
    },
    {
      name: "My Orders"
    }
  ]

  return data && (
    <S.Wrapper>
      <BreadCrumb
        data={breadCrumbData}
      />
      <S.HeaderWrapper>
        <S.Header>
          {
            lastPath === "active-orders" ? 
            <>My Active Orders</>
            :
            <>My orders</>
          }
        </S.Header>
      </S.HeaderWrapper>
      {
        data.orders && data.orders.totalCount > 0 ?
          <>
            <Table responsive className="text-nowrap">  
              <thead>
                <tr>
                  <th>Order</th>
                  <th>Summary</th>
                  <th>Date</th>
                  <th>Payment status</th>
                  <th>Order status</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {data.orders.edges.map((edge, i) => {
                  const order = edge.node;
                  return (
                    <tr key={i}>
                      <td><u style={{cursor: "pointer"}}
                            onClick={(e) => {
                              redirectToMyOrderDetailPage(order.token)
                            }}>
                        {order.number}</u></td>
                      <td>{getPrice(order.total.gross.amount, true)}</td>
                      <td>{getDateTime(order.created)}</td>
                      <td>
                        <LabelStatus
                          label={order.paymentStatusDisplay}
                          status={order.paymentStatusDisplay == "Paid" ? "success" : "unknown"}
                        />
                      </td>
                      <td>
                        {
                          order.paymentStatus != PaymentChargeStatusEnum.NOT_CHARGED && 
                          <LabelStatus
                            label={order.statusDisplay}
                            status={order.statusDisplay == "Dispatched" ? "success" : "unknown"}
                          />
                        }
                      </td>
                      <td><u style={{cursor: "pointer"}}
                            onClick={(e) => {
                              redirectToMyOrderDetailPage(order.token)
                            }}>
                        Detail</u></td>
                    </tr>
                  )
                })}
              </tbody>
            </Table>
            <OffsetPagination
              itemsToShow={ordersToShow}
              startCursor={data.orders.pageInfo.startCursor}
              totalCount={data.orders.totalCount}
              setVariables={setVariables}
              />
          </>
        :
          (<S.NoDataCol>
            <S.NoData>THERE ARE NOT ANY COMPLETED ORDERS YET.</S.NoData>
          </S.NoDataCol>)
        }
    </S.Wrapper>
  ) || <Loading/>;
};

export { OrderListPage }